import type { FC } from 'react';
import React from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { useBooleanFeatureFlag } from '@confluence/session-data';

import { DialogsStateContainer } from './DialogsStateContainer';
import { DialogsComponent } from './DialogsComponent';
import { useDialogsState } from './useDialogs';

export const Dialogs: FC = (props) => {
	const { state } = useDialogsState();
	const isUseDialogsHook = useBooleanFeatureFlag('confluence.frontend.use-dialogs');
	return (
		<Subscribe to={[DialogsStateContainer]}>
			{(dialogs: DialogsStateContainer) => {
				/**
				 * Keep the order of the dialogs by key so we can use unstated dialogs
				 * along side react-sweet-state dialogs. We should expect each array to be
				 * sorted in ascending order by key and we can optimize the merging strategy to linear time.
				 * However, in practice we shouldn't expect the number of active dialogs to be greater than single digits
				 * */
				const stack = isUseDialogsHook
					? [...dialogs.state.stack, ...state.stack].sort((a, b) => a.key - b.key)
					: dialogs.state.stack;
				return <DialogsComponent stack={stack} {...props} />;
			}}
		</Subscribe>
	);
};

export { DialogsStateContainer } from './DialogsStateContainer';
